import type { GeoFailureReason } from './geo-failure-reason'

/** Geo check has not run yet, or state was cleared. */
export const GEO_STATUS_IDLE = 'Idle' as const

/** Geo check ran and failed. */
export const GEO_STATUS_FAILED = 'Failed' as const

/** Geo check ran and succeeded. */
export const GEO_STATUS_SUCCESS = 'Success' as const

export type GeoLocationState =
	| { status: typeof GEO_STATUS_IDLE }
	| Extract<LocateDeviceResult, { status: 'Failed' }> & { reason?: GeoFailureReason }
	| Extract<LocateDeviceResult, { status: 'Success' }>

export const IDLE_STATE: GeoLocationState = { status: GEO_STATUS_IDLE }

let latestLocationResult: GeoLocationState = IDLE_STATE

export function hydrateFromResult(
	result: LocateDeviceResult
): void {
	if (result.status === GEO_STATUS_SUCCESS) {
		latestLocationResult = result
	} else {
		latestLocationResult = result as Extract<LocateDeviceResult, { status: 'Failed' }> & { reason?: GeoFailureReason }
	}
}

export function clearGeoLocationState(): void {
	latestLocationResult = IDLE_STATE
}

export function getLatestLocationResult(): GeoLocationState {
	return latestLocationResult
}

export function getLocationToken(): string | undefined {
	if (latestLocationResult.status === GEO_STATUS_IDLE) return ''
	return latestLocationResult.token
}

export function hasValidLocation(): boolean {
	return latestLocationResult.status === GEO_STATUS_SUCCESS
}

export function getSubdivision(): string {
	if (latestLocationResult.status !== GEO_STATUS_SUCCESS) {
		throw new Error('No valid geolocation subdivision available')
	}
	return latestLocationResult.subdivision
}

export function extractStateFromSubdivision(subdivision: string): string {
	const parts = subdivision.split('-')
	return parts.length > 1 ? parts[1] : subdivision
}

export function getGeoLocationState(): string {
	return extractStateFromSubdivision(getSubdivision())
}
